export * from './lib/core.actions';
export * from './lib/core.models';
export * from './lib/core.module';
export * from './lib/core.module-testing';
export * from './lib/core.reducer';
export * from './lib/core-api.service';
export * from './lib/core-external-app.service';

export * from './lib/core-router.actions';
export * from './lib/core-router.reducer';

export * from './lib/core-http.actions';
export * from './lib/core-http.client';
export * from './lib/core-http.models';
export * from './lib/core-http.reducer';

export * from './lib/core-popup.service';

export * from './lib/app/dynamic-menu/app-dynamic-menu.component';
export * from './lib/app/static-menu/app-static-menu.component';

export * from './lib/google-analytics.service';

// Export core-utils separately to avoid circular dependency issues
export {
  CoreUtils,
  CoreSelectorGuard,
  CoreLoginGuard,
  CoreUtilsService
} from './lib/core-utils';

export {
  BiometricService,
  BIOMETRIC_SERVER_ID,
  BIOMETRIC_STORAGE_KEY,
  type BiometricDisableReason
} from './lib/biometric.service';

export {
  resolveCoreLanguage,
  resolvePickerLocale,
  type CoreResolvedLanguage
} from './lib/core.i18n';
